import 'babel-polyfill';
import 'slick-carousel';
import 'jquery-match-height';
import 'bootstrap-sass/assets/javascripts/bootstrap/collapse';
import 'bootstrap-sass/assets/javascripts/bootstrap/transition';
import GoogleMap from './components/GoogleMap';

class App {
  static init() {
    $(window).scroll(function () {
      $('.parallax-bg').css('background-position', `center ${$(this).scrollTop() / 8}%`);
    });

    $('.js-gmap').each((k, item) => {
      const $map = $(item);
      new GoogleMap($map, $map.data('lat'), $map.data('lng'), $map.data('marker'));
    });

    $('.js-case-studies-carousel').slick({
      prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
    });

    $('.js-category-item-gallery').slick({
      dots: true,
      prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
    });

    $('.js-load-more').on('click', (e) => {
      e.preventDefault();
      $(e.target).hide();
      $('.curtains .columns:hidden').fadeIn();
    });

    $('.js-guides').slick({
      dots: true,
      prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
    });
  }
}

App.init();



// WEBPACK FOOTER //
// ./assets/js/app.js